import { render, staticRenderFns } from "./Branding.vue?vue&type=template&id=229f520b&"
import script from "./Branding.vue?vue&type=script&lang=ts&"
export * from "./Branding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports